import React, { useState } from "react";
import Container from "../../Container";
import Recommendations from "./Recommendations";
import Button from "../../Button";
import tutor from "../../../assets/images/tutor.png";
import tfuel from "../../../assets/svgs/tfuel.svg";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { getTutorial } from "../faketutorialdata";

const TutorialAbout = () => {
  const [purchase, setPurchase] = useState(false);

  const [videoState, setVideoState] = useState({
    playing: false,
    volume: 0.8,
    pip: false,
    controls: false,
    light: false,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    loop: false,
  });

  const { playing, muted, volume } = videoState;

  const handlePlay = () => {
    setVideoState({ ...videoState, playing: !playing });
  };

  const handleMute = () => {
    setVideoState({ ...videoState, muted: !muted });
  };

  const handleVolumeChange = (e: { target: { value: string } }) => {
    setVideoState({ ...videoState, volume: parseFloat(e.target.value) });
  };

  const purchaseTutorial = () => {
    setPurchase(!purchase);
  };

  const { id } = useParams();
  const tutorial = getTutorial(id);
  const { videoLink, price, tutor, tutorialName, rating } = tutorial;
  return (
    <Container>
      <div className="grid grid-cols-[80%_20%] h-[inherit] w-[inherit] font-poppins mt-8">
        <div className="grid grid-rows-[55%_45%] gap-8">
          <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] grid grid-cols-[80%_20%] w-[95%] h-[110%] rounded-xl">
            <div
              className="flex w-[100%] h-[100%] justify-center items-center"
              id="video-wrapper"
            >
              <ReactPlayer
                url={videoLink}
                muted={muted}
                playing={playing}
                width={"100%"}
                height={300}
              />
            </div>
            <div className="h-[75%] pt-4">
              <Button onClick={handlePlay}>{playing ? "Pause" : "Play"}</Button>
              <div>
                <p>Volume</p>
                <input
                  type="range"
                  min={0}
                  max={1}
                  step="any"
                  value={volume}
                  onChange={handleVolumeChange}
                />
              </div>
              <Button onClick={handleMute}>{muted ? "Unmute" : "Mute"}</Button>
            </div>
          </div>
          {purchase ? (
            <TutorialPurchase price={price} rating={rating} tutorName={tutor} />
          ) : (
            <TutorialPreview
              purchaseTutorial={purchaseTutorial}
              tutorialName={tutorialName}
              tutor={tutor}
            />
          )}
        </div>
        <Recommendations />
      </div>
    </Container>
  );
};

export default TutorialAbout;

const TutorialPreview = ({
  tutorialName,
  tutor,
  purchaseTutorial,
}: {
  tutorialName: string;
  tutor: string;
  purchaseTutorial: () => void;
}) => {
  return (
    <div className="text-main-black flex flex-col justify-between py-2 bg-[rgba(255,_255,_255,_0.5)] h-[92%] px-8 [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] w-[95%] rounded-xl">
      <p className="font-medium text-xl">{tutorialName}</p>
      <div className="flex text-[15px]">
        <p className="">{tutor}</p>
        <div className="flex ml-16">
          <p>500 views</p>
          <p>- June 8, 2020</p>
        </div>
      </div>
      <div className="font-light text-[13px]">
        <p>
          Sagittis viverra eget adipiscing quis augue feugiat elit. Ut at
          volutpat posuere vulputate a sollicitudin. Sagittis viverra eget
          adipiscing quis augue feugiat elit. Ut at volutpat posuere vulputate a
          sollicitudin. Sagittis viverra eget adipiscing quis augue feugiat
          elit. Ut at volutpat posuere vulputate a sollicitudin. Sagittis
          viverra eget adipiscing quis augue feugiat elit.{" "}
        </p>
      </div>
      <div className="w-[100%] text-center">
        <Button onClick={purchaseTutorial}>Purchase Tutorial</Button>
      </div>
    </div>
  );
};

const TutorialPurchase = ({
  price,
  rating,
  tutorName,
}: {
  price: number;
  rating?: number;
  tutorName: string;
}) => {
  return (
    <div className="text-main-black grid grid-rows-[78%_22%] py-2 bg-[rgba(255,_255,_255,_0.5)] h-[92%] px-8 [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] w-[95%] rounded-xl">
      <div className="grid grid-cols-[60%_40%]">
        <div className="font-light mt-5">
          <div className="flex">
            <img src={tutor} alt="tutor-pic" />
            <div className="ml-4">
              <p className=" text-lg">{tutorName}</p>
              <p className="text-main-blue text-sm font-medium">Subscribe</p>
            </div>
          </div>
          <p className="text-sm my-5">100 subsribers</p>
          <div></div>
          <i className="text-sm">({rating || 0} star ratings)</i>
        </div>
        <div className="flex flex-col justify-around">
          <div className="flex ml-4">
            <p className="text-2xl font-medium mr-2">{price || "Free"}</p>
            <img src={tfuel} alt="tfuel" />
          </div>
          <div className="w-[50%]">
            <Button>Buy Now</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
